import { render, staticRenderFns } from "./dictionaryType.vue?vue&type=template&id=5761fbb8&scoped=true"
import script from "./dictionaryType.vue?vue&type=script&lang=js"
export * from "./dictionaryType.vue?vue&type=script&lang=js"
import style0 from "./dictionaryType.vue?vue&type=style&index=0&id=5761fbb8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5761fbb8",
  null
  
)

export default component.exports